import React from "react";
import PayPerksNew from "../../../assets/kudzu-plus-images/homepayperks.png";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";


const NewPayPerks = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    return (
        <div className="bg-[#3D645C] rounded-tl-[60px] rounded-br-[60px] w-full h-auto md:w-[859px] md:h-[402px] p-6 md:p-10 flex flex-col md:flex-row items-center md:items-start justify-between shadow-md mx-auto">
            <div className="flex flex-col items-center md:items-start md:w-full md:ml-[15px]">
                <p className="hidden md:block font-hanken-grotesk font-[600] text-[14px] leading-[100%] tracking-[0.1em] uppercase text-white mt-[32px] mb-[20px]">
                    {t('NavbarPerks')}
                </p>
                <h2 className="text-[32px] text-white md:text-3xl font-serif-pro mb-4 text-center md:text-left md:font-[600] md:leading-[100%] md:tracking-[0%] md:capitalize md:whitespace-nowrap">
                    {t('Learn_and')}<span className="hidden md:inline"> </span><br className="md:hidden" />{t('payPerksSubTittle')}
                </h2>
                <p className="font-hanken-grotesk font-medium md:font-[400] text-[18px] leading-[28px] md:leading-[26px] tracking-normal md:tracking-[0%] text-white mb-6 text-center md:text-left w-[360px] max-w-full md:w-[450px]">
                    {t('When_you_use_your')}
                </p>
                <div className="flex items-center mt-14 ml-[60px] md:hidden h-[129px] w-[191px]">
                    <img src={PayPerksNew} alt=""></img>
                </div>
                {/* Mobile button */}
                <button className="md:hidden bg-[#C1ECD9] text-[#00654F] text-[20px] font-semibold px-8 py-4 rounded-full shadow-md mt-[25%] h-[60px]"
                    onClick={() => { navigate('/PayPerks') }}>
                    {t('Get Started')}
                </button>
                {/* Web: button and image in same row, bottom-aligned */}
                <div className="hidden md:flex w-full items-end justify-between mt-auto md:pr-[50px]">
                    <button className="bg-[#C1ECD9] text-[#00654F] font-hanken-grotesk font-[700] text-[18px] leading-[46.09px] tracking-[0%] text-center align-middle rounded-[88.64px] shadow-md w-[159px] h-[55px] pt-[6px] pr-[32px] pb-[6px] pl-[32px] opacity-100"
                        onClick={() => { navigate('/PayPerks') }}>
                        {t('Get Started')}
                    </button>
                    <img src={PayPerksNew} alt="" className="w-[155.69px] h-[94px] opacity-100 mb-[-20px]"></img>
                </div>
            </div>
        </div>
    );
};

export default NewPayPerks;